import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useSummaryCounts = (summary) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  return useMemo(() => {
    const format = (num) => Intl.NumberFormat(language).format(num);
    const {
      text = '',
      not_allowed_count = 0,
      valid_count = 0,
      subscriptions,
      stages,
      limits,
    } = summary || {};

    const count = format(valid_count);

    const notAllowed = format(not_allowed_count);

    const notIncludedString = [
      not_allowed_count && `${notAllowed} ${t('Insufficient Permissions')}`,
      subscriptions?.opted_out &&
        `${format(subscriptions.opted_out)} ${t('Opted Out')}`,
      subscriptions?.unsubscribed &&
        `${format(subscriptions.unsubscribed)} ${t('Unsubscribed')}`,
      subscriptions?.in_suppression_list &&
        `${format(subscriptions.in_suppression_list)} ${t('Suppression List')}`,
      stages?.won_count && `${format(stages.won_count)} ${t('Won')}`,
      stages?.lost_count && `${format(stages.lost_count)} ${t('Lost')}`,
      stages?.disqualified_count &&
        `${format(stages.disqualified_count)} ${t('Disqualified')}`,
      limits?.insufficient_credits &&
        `${format(limits.insufficient_credits)} ${t('Insufficient Credits')}`,
    ]
      .filter(Boolean)
      .join(', ');

    return {
      countNum: valid_count,
      count,
      selected: text,
      notIncludedString,
    };
  }, [summary, t, language]);
};
